import { defaultErrorMsg } from './rsuite/Alerts';

// eslint-disable-next-line no-unused-vars
const { errorStrings, errorWords, errorCodes } = require('../constants/errors/error');

const referenceError = [10010290, 10010390, 10010790, 10010890, 10010990, '00489901', 'EXT01XXX001'];

export function getDataError (error) {
    try {
        const data =
            error?.response?.data?.task?.result ||
            error?.task?.result ||
            error?.response?.data ||
            (() => {
                try {
                    return JSON.parse(error?.message);
                }
                catch {
                    return {};
                }
            })();

        const extra =
            error?.extra ||
            data?.extra ||
            data?.error?.extra;

        if (extra) {
            return {
                ...data,
                extra
            };
        }

        return data;
    }
    catch (e) {
        console.error('get dataError helper: ', e);
        return {};
    }
};

export function errorMapper (e) {
    try {
        // Error original
        console.error(e);

        const dataError = getDataError(e);
        const isFromCuotitas = Object?.hasOwnProperty?.call(dataError?.extra?.result || {}, 'Mensaje');
        const matchesList = [];
        let msg = dataError?.error || dataError?.name;

        // let msg = defaultErrorMsg;
        // Error que vienen de loan (cuotitas)
        if (isFromCuotitas) {
            // sometimes loan responses come without a dot
            msg = `${dataError.extra?.result?.Mensaje}. `.replace('..', '.');
            // If Mensaje is void // TODO ponerlo unicamente en ObtenerPersona ValidarCliente
            if (!dataError?.extra?.result?.Mensaje.length) {
                msg = 'No hay detalle del error proveniente de LOAN. ';
            }
        };

        // Search the error in our error library (it could be our errors or cuotitas api errors)
        if (msg?.length) {
            for (let i = 0; i < errorStrings.length; i++) {
                const eString = errorStrings[i];
                if (msg.includes(eString.description)) {
                    eString.message = putReferenceNumber(msg, eString);
                    matchesList.push(eString);
                }
            }
        }

        // Generic error object response
        let customResponse = {
            code: dataError?.code,
            description: dataError?.error || dataError?.name,
            message: isFromCuotitas ? msg : defaultErrorMsg,
            type: 'error',
            time: 0,
            request: '/'
        };

        // Choose error with more matches
        if (matchesList.length) {
            customResponse = getMaxMatches(matchesList, msg);
        }

        // Error by error name
        if (msg && (errorWords[msg] || errorWords[customResponse.description])) {
            customResponse = errorWords[msg] || errorWords[customResponse.description];
        };

        // Error by code
        // Código de error enviado por nuestro core
        if (dataError?.extra && errorCodes[dataError?.extra?.idError]) {
            customResponse = errorCodes[dataError?.extra?.idError];
        };

        // Finally if is from cuotitas we add 1001 or When cuotitas api don't work
        if (isFromCuotitas || dataError?.extra?.from === 'Cuotitas') {
            customResponse = {
                ...customResponse,
                message: `1001: ${customResponse.message || msg}`
            };
        }

        return customResponse;
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error mapper helper: ', error);
    }
}

//
// AUXILIARIES FUNCTIONS
//

/**
 * Get an amount o matches between arrays
 * @param {Array} a1 first array
 * @param {Array} a2 second array
 * @returns {Integer} Integer of matches between arrays
 */
const compare = (a1, a2) => a1.reduce((a, c) => a + a2.includes(c), 0);

/**
 * Get max object with max count of matches between description & msg
 * @param {Array} list [{ description: 'first word'}, { description: 'second word'}, ...]
 * @param {String} msg 'phrase'
 * @returns {Object} Object with more coincidence
 */
function getMaxMatches (list, msg) {
    let index = 0;
    let matches = 0;
    const msgSplited = msg.split(' ');

    for (let i = 0; i < list.length; i++) {
        const _error = list[i];
        const count = compare(_error.description.split(' '), msgSplited);

        if (count > matches) {
            index = i;
            matches = count;
        };
    }

    return list[index];
}

/**
 * Custom error that can return objects
 */
export class CustomError extends Error {
    constructor (message) {
        super(JSON.stringify(message));
        this.name = this.constructor.name;
        this.response = {
            data: JSON.parse(this.message)
        };
        // this.code = code;
        // this.extra = extra;
        // Error.captureStackTrace(this, this.constructor);
    }

    from () {
        // const json = {
        //     error: this.message,
        //     code: this.code
        // };

        // if (this.extra) {
        //     json.extra = this.extra;
        // }
        // this.response.data = JSON.parse(this.message);
        return JSON.parse(this.message);
    }
}

/**
 * Replace {nro} text by number reference
 * @param {String} msg is a sentence with number reference
 * @param {Object} eString is errorString
 * @returns string
 */
function putReferenceNumber (msg, eString) {
    if (referenceError.includes(eString.code)) {
        const reference = msg.match(/\d+/g) || [];
        const lastElement = reference.length - 1;
        // If is not number we return the same message
        if (!reference[lastElement]) {
            return eString?.message;
        }
        // Replace {nro} to real number of reference
        return eString?.message.replace(/{nro}/g, reference[lastElement]);
    }

    return eString?.message;
}
